import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import ConversationItem from "@/components/ConversationItem.vue";
import { useConversationStore } from "@/stores/conversation";
import { useConfigStore } from '@/stores/config';
import CoreService from "@/services/core.service";
import { onMounted, ref } from "vue";
import { MessengerMode } from "@/types/Messenger";
import { useRoute } from "vue-router";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FloatingConversation',
    setup(__props) {
        const id = ref(null);
        const route = useRoute();
        const store = useConversationStore();
        const configStore = useConfigStore();
        const conversationClicked = () => {
            configStore.setMessengerMode(MessengerMode.NORMAL);
            CoreService.replace('Conversation', { id: id.value });
        };
        const lastMessage = (id) => {
            return store.getLastMessage(id);
        };
        onMounted(() => {
            id.value = route.params.id || null;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", {
                    onClick: conversationClicked,
                    class: "cursor-pointer"
                }, [
                    _createVNode(ConversationItem, {
                        message: lastMessage(id.value)
                    }, null, 8, ["message"]),
                    _createTextVNode(" hey ")
                ])
            ]));
        };
    }
});
